/* eslint-disable local/no-raw-colors */
import React from 'react'
import type { SvgProps } from 'react-native-svg'
import { ClipPath, Defs, G, Path, Rect, Svg } from 'react-native-svg'

export const Airline: React.FC<SvgProps> = props => (
    <Svg viewBox='0 0 24 24' {...props}>
        <G clipPath='url(#clip0_46_1441)'>
            <Path
                d='M17.5264 3C17.9459 3.00005 18.3123 3.15624 18.627 3.46973C18.9417 3.78333 19.0957 4.14634 19.0898 4.55859C19.0845 4.97008 18.9298 5.32713 18.627 5.62891L14.627 9.61426L16.8105 19.0664L15.3779 20.4941L12.6523 15.3232L10.6055 17.3623L10.9727 19.9209L9.88965 21L9.1748 19.7314L8.77344 16.9297L11.8721 13.8418L11.3594 12.8701L7.35938 16.8564L7.72656 19.4141L6.64355 20.4941L4.80859 17.2393L1.56055 15.4287L2.64355 14.3496L5.17578 14.6807L9.17676 10.6943L1.56055 6.72656L2.99316 5.29883L12.4424 7.43848L16.4434 3.45215C16.7462 3.15045 17.1068 3 17.5264 3ZM20.7734 3.50684C21.1929 3.50695 21.5594 3.6631 21.874 3.97656C22.1887 4.29016 22.3428 4.65318 22.3369 5.06543C22.3316 5.47697 22.1769 5.83394 21.874 6.13574L17.874 10.1211L20.0566 19.5723L18.6484 20.9756L18.2246 19.1396L16.1729 10.2598L16.04 9.6875L20.041 5.70117C20.3436 5.39951 20.4979 5.04374 20.5039 4.63184C20.5092 4.26342 20.3858 3.9349 20.1348 3.64551C20.3301 3.55415 20.5428 3.50684 20.7734 3.50684ZM27.5605 16.1797L27.5244 16.2158L27.4873 16.1797L27.5244 16.1426L27.5605 16.1797Z'
                fill='#E5E5E6'
            />
        </G>
        <Defs>
            <ClipPath id='clip0_46_1441'>
                <Rect fill='white' />
            </ClipPath>
        </Defs>
    </Svg>
)
